import { useContext } from 'react';
import {
  GlobalConfirmDeleteDialogContext,
  GlobalConfirmDeleteDialogContextValue
} from '../context/GlobalConfirmDeleteDialogContext';

export function useGlobalConfirmDeleteDialog(): GlobalConfirmDeleteDialogContextValue {
  return useContext(GlobalConfirmDeleteDialogContext);
}
